import Config from "../../../common/Config";
import {
  getCachedCompanySettings,
  isRhpInvoiceFormatA4,
} from "../../../../utils/companySettingsCache";

export const isRhpPrintTenant = () => {
  if (Config.PREFIX === "rhp") {
    return true;
  }
  const accessToken = String(localStorage.getItem("accessToken") || "").toLowerCase();
  return accessToken === "rhp" || accessToken === "hp";
};

export const getRhpUserRole = () =>
  String(localStorage.getItem("user_role") || "").trim();

export const isRhpInvoicePrintRole = () => {
  const role = getRhpUserRole();
  return role === "18" || role === "19" || role === "20";
};

export const shouldUseRhpInvoicePrint = () =>
  isRhpPrintTenant() && isRhpInvoicePrintRole();

export const getRhpDefaultInvoicePrintUrl = (orderId, { autoprint = false, statusTab = "" } = {}) => {
  const params = new URLSearchParams();
  params.set("orderId", String(orderId));
  if (statusTab) {
    params.set("statusTab", String(statusTab));
  }
  if (autoprint) {
    params.set("autoprint", "1");
  }
  return `${Config.BASE_URL}/invoice/right-price-wholsale.html?${params.toString()}`;
};

export const getRhpA4InvoicePrintUrl = (orderId, { autoprint = false } = {}) => {
  const params = new URLSearchParams();
  params.set("orderId", String(orderId));
  if (autoprint) {
    params.set("autoprint", "1");
  }
  return `${Config.BASE_URL}/invoice/right-price-a4.html?${params.toString()}`;
};

export const getStandardInvoicePrintUrl = (orderId, { autoprint = false } = {}) => {
  const accessToken = localStorage.getItem("accessToken") || "";
  const params = new URLSearchParams();
  params.set("orderId", String(orderId));
  params.set("prefix", accessToken);
  if (autoprint) {
    params.set("autoprint", "1");
  }
  return `${Config.BASE_URL}/invoice/sales_invoice.html?${params.toString()}`;
};

export const getRhpInvoicePrintUrl = (
  orderId,
  { settings = null, autoprint = false, statusTab = "" } = {}
) => {
  if (!shouldUseRhpInvoicePrint()) {
    return getStandardInvoicePrintUrl(orderId, { autoprint });
  }

  const role = getRhpUserRole();
  if (role === "20") {
    return getRhpDefaultInvoicePrintUrl(orderId, { autoprint, statusTab });
  }

  const resolvedSettings =
    settings !== null && settings !== undefined
      ? settings
      : getCachedCompanySettings();

  if (isRhpInvoiceFormatA4(resolvedSettings)) {
    return getRhpA4InvoicePrintUrl(orderId, { autoprint });
  }

  return getRhpDefaultInvoicePrintUrl(orderId, { autoprint, statusTab });
};
